/**
 * Escape a value for interpolation into raw HTML.
 *
 * <p>The print routines build a ticket/receipt as an HTML string and hand it to
 * `document.write` on a same-origin `about:blank` popup, so any unescaped field is executable
 * script in our own origin — a patient name is attacker-controlled text that reaches this path
 * (#18623).
 *
 * <p>This lives in one place because it previously did not: two print routines carried their own
 * copy of `esc` and the third simply forgot one, which is exactly the failure a duplicated
 * security helper invites. Escaping quotes as well as angle brackets means the same function is
 * safe in an attribute value, not only in text.
 *
 * <p>It is NOT a sanitiser: it makes a value inert as markup. It cannot make attacker-supplied
 * markup safe to render, so never reach for it to "clean" HTML you intend to keep as HTML.
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value).replace(
    /[&<>"']/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c] ?? c
  );
}
